export { default } from "./CheckoutPayment.jsx";
